import objectFitImages from "object-fit-images";

exports.onInitialClientRender = () => {
  objectFitImages();
};



// WEBPACK FOOTER //
// ./gatsby-browser.js